import { render, staticRenderFns } from "./UsageStats.vue?vue&type=template&id=4394deae&scoped=true"
import script from "./UsageStats.vue?vue&type=script&lang=js"
export * from "./UsageStats.vue?vue&type=script&lang=js"
import style0 from "./UsageStats.vue?vue&type=style&index=0&id=4394deae&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4394deae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4394deae')) {
      api.createRecord('4394deae', component.options)
    } else {
      api.reload('4394deae', component.options)
    }
    module.hot.accept("./UsageStats.vue?vue&type=template&id=4394deae&scoped=true", function () {
      api.rerender('4394deae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UsageStats.vue"
export default component.exports